import RatingResource from "./rating.resource";

const ratingModule = angular
  .module("app.resources.rating", [])
  .service("Rating", RatingResource);

export default ratingModule;



// WEBPACK FOOTER //
// ./src/resources/rating/rating.module.js